export const environment = {
  "production": false,
  "appName": "@ec/fleet-dashboard-v2",
  "appVersion": "1.0.22",
  "apiUrl": "https://public.dev5.dev5.elevationcurb.com/api/v1",
  "webAppUrl": "https://webapp.dev5.dev5.elevationcurb.com",
  "hubAppUrl": "https://hub.dev5.dev5.elevationcurb.com",
  "installationApiUrl": "https://install.dev5.dev5.elevationcurb.com/api",
  "liveDataServiceUrl": "wss://lds.dev5.dev5.elevationcurb.com",
  "timezoneApiKey": "AIzaSyD3NiA0YUwPfnOPGP5fyWkWdNtO5LIlQlU",
  "auth0": {
    "domain": "dev5a-curbenergy.us.auth0.com",
    "clientId": "GeexgS5PqqwjYABAbHjDPVGocuIGvlPX",
    "redirectUri": window.location.origin,
    "audience": "public.energycurb.com",
    "responseType": "token id_token",
    "scope": "openid profile email",
    "connection": "users"
  }
};
